import { defineMessages } from "react-intl";

import { EntityType } from "@mapmycustomers/shared";

const messages = defineMessages({
  addNewCompanyButton: {
    id: "associations.companies.addNewCompanyButton",
    defaultMessage:
      "+ Add New {sourceObject, select, standard {Company} leadCompanies {Lead} siteCompanies {Site} projectCompanies {Project} shopCompanies {Shop} other {{label}}}",
    description:
      'Add new company button on Company association modal. The record type name comes from the select: the web\'s own word for a known type, otherwise {label}, a name an admin typed or an integration sent. Keep {label} in its base form. In es, pt and fr, no article, adjective or participle may agree with it: put gendered words on the noun "record" with the name in parentheses, or put a verb before the name. In a choice that creates a record, use a form like "Добавить: {label}".',
  },
  alreadyAssociated: {
    id: "associations.companies.alreadyAssociated",
    defaultMessage:
      "This company is already associated with this record. To remove the association, click the “Remove” icon from the edit panel.",
    description: "A tooltip over the checkbox when company is already assigned to a target record",
  },
  associationLimitError: {
    id: "associations.companies.associationLimitError",
    defaultMessage: "You can only relate up to {limit} Companies to an individual {entity}",
    description: "Title of limit reached error",
  },
  cantAssociateWithSelf: {
    id: "associations.companies.cantAssociateWithSelf",
    defaultMessage:
      "Assigning {sourceObject, select, standard {company} leadCompanies {lead} siteCompanies {site} projectCompanies {project} shopCompanies {shop} other {{label}}} to itself is not allowed",
    description:
      'A tooltip over the checkbox when company is already a target company. The record type name comes from the select: the web\'s own word for a known type, otherwise {label}, a name an admin typed or an integration sent. Keep {label} in its base form. In es, pt and fr, no article, adjective or participle may agree with it: put gendered words on the noun "record" with the name in parentheses, or put a verb before the name. In a choice that creates a record, use a form like "Добавить: {label}".',
  },
  deselectCount: {
    id: "associations.companies.title.deselect.count",
    defaultMessage: "{count, plural, one {# company} other {# companies}} deselected",
    description: "Title of Company Association modal with deselected count",
  },
  [EntityType.ACTIVITY]: {
    id: "associations.companies.addNewCompanyModal.activity",
    defaultMessage: "Activity",
    description: "Activity text",
  },
  [EntityType.COMPANY]: {
    id: "associations.companies.addNewCompanyModal.company",
    defaultMessage: "Company",
    description: "Company text",
  },
  [EntityType.DEAL]: {
    id: "associations.companies.addNewCompanyModal.deal",
    defaultMessage: "Deal",
    description: "Deal text",
  },
  [EntityType.PERSON]: {
    id: "associations.companies.addNewCompanyModal.person",
    defaultMessage: "Person",
    description: "Person text",
  },
  [EntityType.TRIP]: {
    id: "associations.companies.addNewCompanyModal.trip",
    defaultMessage: "Drive",
    description: "Drive text",
  },
  errorTitle: {
    id: "associations.companies.error.title",
    defaultMessage: "Limit of related companies reached",
    description: "Title of limit reached error",
  },
  footerOkButton: {
    id: "associations.companies.footer.footerOkButton",
    defaultMessage:
      "{addCompanies, select, true {Add} other {Update}} {multiselect, select, true {Companies} other {Company}}",
    description: "Add button title on Company Associations modal",
  },
  header: {
    id: "associations.companies.header",
    defaultMessage: "Select {multiselect, select, true {Companies} other {Company}}",
    description: "Header of Company Associations modal",
  },
  modalOkButton: {
    id: "associations.companies.addNewCompanyModal.okButton",
    defaultMessage:
      "Create and Add {sourceObject, select, standard {Company} leadCompanies {Lead} siteCompanies {Site} projectCompanies {Project} shopCompanies {Shop} other {{label}}}",
    description:
      'Create button title on Create Company modal when called from Select Companies modal. The record type name comes from the select: the web\'s own word for a known type, otherwise {label}, a name an admin typed or an integration sent. Keep {label} in its base form. In es, pt and fr, no article, adjective or participle may agree with it: put gendered words on the noun "record" with the name in parentheses, or put a verb before the name. In a choice that creates a record, use a form like "Добавить: {label}".',
  },
  notEditable: {
    id: "associations.companies.notEditable.description",
    defaultMessage:
      "You don't have permission to edit this company, so it can't be added as a parent or child. Please choose a company you can edit, or ask your admin for access.",
    description:
      "Error shown when the user tries to link a company they don't have permission to edit as a parent or child",
  },
  notEditableRowTooltip: {
    id: "associations.companies.notEditable.rowTooltip",
    defaultMessage: "You don't have permission to edit this company",
    description: "Tooltip on a disabled company row the user isn't allowed to link",
  },
  notEditableTitle: {
    id: "associations.companies.notEditable.title",
    defaultMessage: "Can't link this company",
    description: "Error title shown when the user lacks permission to link a company",
  },
  placeholder: {
    id: "associations.companies.search.placeholder",
    defaultMessage: "Search for a company",
    description: "Search bar placeholder for company association modal",
  },
  selectedCount: {
    id: "associations.companies.title.selected.count",
    defaultMessage: "{count, plural, one {# new company} other {# new companies}} selected",
    description: "Title of Company Association modal with selected count",
  },
});

export default messages;
